import * as React from "react";
import PropTypes from "prop-types";
import LoadingOverlay from 'react-loading-overlay'
import BounceLoader from 'react-spinners/BounceLoader'
 
export const Loading = ( { active, children } ) => {
  return (
    <LoadingOverlay
      active={active}
      spinner={<BounceLoader color="pink" css={{display: 'block', margin: 'auto', marginBottom: 20}}/>}
      text={'Loading ...'}
    >
        {children}
    </LoadingOverlay>
  )
}

Loading.propTypes = {
  active: PropTypes.bool,
  text: PropTypes.string
};

export default Loading;